// extracted by mini-css-extract-plugin
export var active = "_71-b";
export var activeIndicator = "_71-6";
export var animate = "_71-a";
export var disabled = "_71-c";
export var flat = "_71-1";
export var fullWidth = "_71-3";
export var lg = "_71-9";
export var md = "_71-8";
export var redoButtonTabGroup = "_71-0";
export var sm = "_71-7";
export var tabButton = "_71-4";
export var tabButtonsContainer = "_71-2";
export var xs = "_71-5";